export default __webpack_public_path__ + "static/slider-4-6999bb40fe80963784d670228c97e8eb.jpg";